export default __webpack_public_path__ + "static/media/work3.cc6c1751.jpg";